import styled from "styled-components";

export const WorkSpace = styled.div`
  overflow: auto;
  height: calc(100vh - 70px);
`;
